import { render } from "./ValueDeclarants.vue?vue&type=template&id=856739a2&scoped=true"
import script from "./ValueDeclarants.vue?vue&type=script&lang=js"
export * from "./ValueDeclarants.vue?vue&type=script&lang=js"

import "./ValueDeclarants.vue?vue&type=style&index=0&id=856739a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-856739a2"]])

export default __exports__